import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import PostLoginLayout from "../components/layouts/PostLoginLayout";
import FileListComponent from "../components/FileListComponent";

const FileList = () => {
  const location = useLocation();

  let FileListContainer = <FileListComponent />;

  return <PostLoginLayout childComponent={FileListContainer} noLeftPanel={false} loader={false}/>;
};

export default FileList;
